import { UiKitContextProvider, UiKitToastsContextProvider } from '@cian/ui-kit';
import * as React from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from '../../../types/applicationContext';
import { ApplicationContext } from '../../../utils/applicationContext';
// import { openEventChannel } from '../../actions/socket';
import { useBlinkingTitle } from '../../hooks/useBlinkingTitle';
import { IReduxStore } from '../../types/redux/store';
import { NotificationsContainer } from '../Notifications';

export interface IApplicationProps {
  context: IApplicationContext;
  store: IReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ context, store }) => {
  useBlinkingTitle(context);

  return (
    <ApplicationContext.Provider value={context}>
      <UiKitContextProvider useStaticDeviceType>
        <UiKitToastsContextProvider>
          <Provider store={store}>
            <NotificationsContainer />
          </Provider>
        </UiKitToastsContextProvider>
      </UiKitContextProvider>
    </ApplicationContext.Provider>
  );
};
